export default __webpack_public_path__ + "static/wrapped_bitcoin-40dd0704b439e4f3f817aee19dfdb819.png";